import { render } from "./reset_password.vue?vue&type=template&id=770a6a70&scoped=true"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"

import "./reset_password.vue?vue&type=style&index=0&id=770a6a70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770a6a70"]])

export default __exports__